// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"800a451e","453":"08883967"}[chunkId] + ".chunk.js";
};